export default __webpack_public_path__ + "static/media/product3.641b768f.webp";